import { useSelector } from 'react-redux';
import Table from '../../components/tables/Table';

const Evaluator = () => {
    const evaluators = useSelector(state => state.evaluators)
    const table = {
        title : 'Evaluators',
        tHeaders : [ 'Access code', 'Name', 'Email', 'Address', 'LGA', 'Zone', 'State', 'Status', 'Created At' ],
        tProperties : [  'access_code', 'name', 'email', 'address', 'lga', 'zone', 'state', 'status', 'createdAt' ],
    }

    return (
        <div>
            <h1>Manage {table.title}</h1>
            <Table table={table} data={ evaluators } />
        </div>
    )
}

export default Evaluator;